import { ReactFlowProvider } from '@xyflow/react';
import { createContext } from 'react';
import { SweepCanvasStateProvider } from './internal-context/CanvasStateContext';
import { CanvasControlsCtxProvider } from './canvas-controls/CanvasControlsCtx';
import { CanvasFreeElementContextProvider } from './canvas-element-tool/CanvasFreeElementContext';

export const SweepCanvasProvidersInitializedCtx = createContext<boolean>(false);

export const SweepCanvasProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <SweepCanvasProvidersInitializedCtx.Provider value={true}>
      <CanvasControlsCtxProvider>
        <SweepCanvasStateProvider>
          <CanvasFreeElementContextProvider>
            <ReactFlowProvider>{children}</ReactFlowProvider>
          </CanvasFreeElementContextProvider>
        </SweepCanvasStateProvider>
      </CanvasControlsCtxProvider>
    </SweepCanvasProvidersInitializedCtx.Provider>
  );
};
